import React from 'react'
import banner from "../Assets/Images/us-photo.jpg";
import wwa from "../Assets/Images/wwa.jpg"
import { Navbar } from 'react-bootstrap';

function About() {
  return (
      <>
<Navbar/>
      
     <div className="relative min-h-screen text-white">

      {/* Background */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-fixed blur-sm"
        style={{ backgroundImage: `url(${banner})` }}
      ></div>

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/50"></div>

      {/* Content */}
      <div className="relative z-10 flex items-center justify-center min-h-screen px-6">
        <div className="max-w-2xl text-left ">

          {/* Heading */}
          <h1 className="text-2xl md:text-3xl font-bold inline-block border-b-4 border-red-500 pb-2">
           Who we are
          </h1>

          {/* Paragraph */}
          <p className="mt-6 text-sm md:text-xl leading-relaxed">
            An Isiolo where young people live dignified lives free from poverty and injustice.
          </p>

        </div>
      </div>

    </div>


    
    <div className="bg-white py-20 px-6">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center">

        {/* Left - Image */}
        <div className="relative">
          <img
            src={wwa}
            alt="About"
            className="rounded-2xl shadow-xl w-full h-[500px] object-cover"
          />

          {/* Decorative element */}
          <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-red-500 rounded-xl opacity-80"></div>
        </div>

        {/* Right - Content */}
        <div>

          {/* Section Title */}
          <h2 className="text-2xl md:text-3xl font-bold text-black mb-10 relative inline-block">
            Disover Us
            <span className="block w-20 h-1 bg-red-500 mt-2"></span>
          </h2>

         {/* Mission */}
<div className="mb-6 text-justify border border-red-500 p-4 md:p-6 rounded-lg">
  <h3 className="text-lg md:text-xl font-semibold text-red-500 mb-2">
    Our Mission
  </h3>
  <p className="text-gray-600 leading-relaxed text-sm md:text-base">
    To empower communities through innovative solutions that enhance 
    productivity, create opportunities, and drive sustainable development 
    across multiple sectors.
  </p>
</div>

{/* Vision */}
<div className="mb-6 text-justify border border-red-500 p-4 md:p-6 rounded-lg">
  <h3 className="text-lg md:text-xl font-semibold text-red-500 mb-2">
    Our Vision
  </h3>
  <p className="text-gray-600 leading-relaxed text-sm md:text-base">
    To become a leading force in transforming lives by leveraging 
    technology, partnerships, and forward-thinking strategies that 
    shape a better future.
  </p>
</div>

          {/* Origin Story */}
          <div>
            <p className="text-gray-600 text-sm md:text-base leading-relaxed text-justify mb-2">
              Isiolo Advocacy Network is a non-partisan, non-religious youth-led Community-Based Organization working to advance social and climate justice in Isiolo County.
            </p>
             <p className="text-gray-600 leading-relaxed text-justify mb-2">
             Our journey began in 2020 as a grassroots movement under Activista, driven by young people determined to create positive change in their community. We recognized the systemic barriers faced by marginalized groups — particularly youth and women — and began organizing around issues of inequality, environmental degradation, and lack of meaningful participation in decision-making spaces.
            </p>
             <p className="text-gray-600 leading-relaxed text-justify mb-2">
              As the movement grew, so did our vision. To strengthen our impact and expand our reach, we formalized our work and established the Isiolo Advocacy Network as a registered Community-Based Organization.
            </p>
             <p className="text-gray-600 leading-relaxed text-justify mb-2">
              Today, we work across 6 wards in Isiolo County, partnering with communities to address poverty, climate injustice, gender inequality, and exclusion. Our approach centers on empowerment, solidarity, and advocacy — ensuring that youth, women, and marginalized communities are not only heard, but are leading the change.
            </p>
             <p className="text-gray-600 leading-relaxed text-justify mb-2">
              We believe sustainable solutions already exist within communities. Our role is to organize, amplify voices, and create platforms where justice, dignity, and resilience can thrive.
            </p>
          </div>

        </div>
      </div>
    </div>
      </>

  )
}

export default About